module.exports = __webpack_public_path__ + "img/borrow.21277a84.svg";